import { combineReducers } from 'redux';
import emergencyBanner from './emergencyBanner';
import menu from './menu';
import popup from './popup';
import scroll from './scroll';
import submitting from './submitting';
import symptom from './symptom';
import textInput from './textInput';
import window from './window';

export default combineReducers({
  emergencyBanner,
  menu,
  popup,
  scroll,
  submitting,
  symptom,
  textInput,
  window,
})

export interface ActionType {
  type: string;
  [key: string]: any;
};



// WEBPACK FOOTER //
// ./src/reducers/index.tsx